import { useBack } from "../http";
import { AccountDTO } from "../types/AccountDTO";

export class AccountService {
	constructor() {}
	axiosInstance = useBack();

	async getAccounts() {
		try {
			const response = await this.axiosInstance.get<AccountDTO[]>('/account');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os usuários`, error);
			return undefined;
		}
	}

	async deleteAccount(username: string) {
		try {
			const response = await this.axiosInstance
				.delete(`/account/${username}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível deletar o usuário ${username}`, error);
			return undefined;
		}
	}

	async edit(edit: AccountDTO) {
		if (!edit) return;
		try {
			const response = await this.axiosInstance
				.put(`/account`, edit);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível editar o usuário ${edit.username}`, error);
			return undefined;
		}
	}
}